import { useEffect } from 'react'
import { useAppContext } from '../contexts/AppContext'

/**
 * It is used to register an API of a node component (to be able control and manipulate it outside)
 * (User Story 15319: New action property: Auto launch)
 * **/
export default function useComponentsApiRegistry<T>(nodeId: number, apiBuilder: () => T): void {
  const { componentsApiRegistry } = useAppContext()
  useEffect(() => {
    if (!componentsApiRegistry) {
      return
    }

    componentsApiRegistry.register(nodeId, apiBuilder())
    return () => {
      componentsApiRegistry.unregister(nodeId)
    }
  })
}
